<template>
  <div
    class="row"
  >
    <div
      class="col-md-4"
      v-if="GET_IS_MANAGED_CAMPAIGN"
    >
      <div class="form-group mt-5">
        <label class="form-label mb-3">Who to invoice?</label>
        <b-form-select
          class="custom-select"
          v-model="selectedInvoiceType"
          :options="invoiceType"
          data-test="invoice-type-select"
          @change="updateSelection(null)"
          :disabled="disableInvoicingTypeSelector"
        />
      </div>
    </div>
    <b-col
      :cols="GET_IS_MANAGED_CAMPAIGN? 8 : 12"
    >
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">
            Invoicing details <span v-if="GET_IS_MANAGED_CAMPAIGN"> for {{ getName() }} </span>
          </h3>
          <span
            class="form-label-small text-muted ml-auto"
          >
            <button
              data-test="edit-billing-button"
              type="button"
              class="btn btn-secondary btn-sm"
              @click="addNewInvoicingDetails()"
              v-if="selectedInvoiceType !== null"
              :disabled="GET_IS_CAMPAIGN_READONLY"
            >
              Add new
            </button>
          </span>
        </div>
        <div
          class="card-body o-auto"
          style="height: 15rem"
        >
          <div
            class="text-muted text-center"
            v-if="selectedInvoiceType === null"
          >
            Please select a type.
          </div>
          <div
            class="text-muted text-center"
            v-else-if="this.getInvoicingList.length === 0"
          >
            Please add new invoicing details.
          </div>
          <ul
            class="list-unstyled list-separated invoicing-details-list"
            v-else
          >
            <InvoicingSelectionListItem
              v-for="item in getInvoicingList"
              :key="item.id"
              :item="item"
              :selected-details-id="selectedDetailsId"
              @updateSelection="updateSelection"
            />
          </ul>
        </div>
      </div>
    </b-col>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import InvoicingSelectionListItem from '@/modules/account/components/InvoicingSelectionListItem';

export default {
  name: 'InvoicingSelection',
  components: {
    InvoicingSelectionListItem,
  },
  props: {
    invoicingLists: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedInvoiceType: null,
      invoiceType: [
        { value: null, text: 'Please select' },
        { value: 'advertiser', text: 'Advertiser' },
        { value: 'agency', text: 'Agency' },
      ],
      selectedDetailsId: null,
      invoicingDetailsList: {},
    };
  },
  computed: {
    ...mapState('campaigns', [
      'order',
      'campaign',
      'agencies',
      'selectedAdvertiser',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_MANAGED_CAMPAIGN,
      campaignTypes.GET_IS_CAMPAIGN_READONLY,
    ]),
    getInvoicingList() {
      if (this.selectedInvoiceType === null) return [];
      const listSelectedCurrencyFiltered = this.invoicingDetailsList[this.selectedInvoiceType]
        .filter((val) => val.billingCurrencyId === this.order.currencyId);
      const listFiltered = this.invoicingDetailsList[this.selectedInvoiceType]
        .filter((val) => val.billingCurrencyId !== this.order.currencyId);
      return [...listSelectedCurrencyFiltered, ...listFiltered];
    },
    disableInvoicingTypeSelector() {
      return this.isNoneAgency() || this.GET_IS_CAMPAIGN_READONLY;
    },
  },
  methods: {
    updateSelection(id) {
      this.selectedDetailsId = id;
      if (id === null) {
        this.$emit('updateDetailsSelected', false);
        return this.$emit('resetDetailsForm');
      }
      const invoicingDetails = this.getInvoicingList
        .find((item) => (item.id === id));
      this.$emit('setInvoicingDetails', invoicingDetails);
      this.$emit('updateDetailsSelected', true);
    },
    addNewInvoicingDetails() {
      this.selectedDetailsId = null;
      this.$emit('resetDetailsForm');
      this.$emit('updateDetailsSelected', true);
    },
    getName() {
      if (this.selectedInvoiceType === 'advertiser') {
        return this.selectedAdvertiser.name;
      }
      if (this.selectedInvoiceType === 'agency') {
        return this.getAgencyName();
      }
      return '....';
    },
    getAgencyName() {
      const { agencyId } = this.campaign;
      const agency = this.agencies.filter((a) => a.id === agencyId)[0];
      return agency ? agency.name : '';
    },
    isNoneAgency() {
      return this.getAgencyName() === 'NONE';
    },
  },
  created() {
    this.invoicingDetailsList = this.invoicingLists;
    if (this.isNoneAgency()) {
      this.selectedInvoiceType = 'advertiser';
    }

    if (!this.GET_IS_MANAGED_CAMPAIGN) {
      let foundDetails = this.invoicingDetailsList.account
        .find((invDetails) => invDetails.id === this.campaign.invoicingDetailsId);

      if (!foundDetails && this.invoicingDetailsList.campaign.length === 1) {
        foundDetails = this.invoicingDetailsList.campaign[0];
        this.invoicingDetailsList.combined = [foundDetails].concat(this.invoicingDetailsList.account);
        this.selectedInvoiceType = 'combined';
      } else {
        this.selectedInvoiceType = 'account';
      }
      this.selectedDetailsId = foundDetails ? this.campaign.invoicingDetailsId : null;

      this.updateSelection(this.selectedDetailsId);
    }

    if (this.campaign.invoicingDetailsId) {
      if (this.GET_IS_MANAGED_CAMPAIGN) {
        const advertiserIndex = this.invoicingDetailsList.advertiser
          .findIndex((invDetails) => invDetails.id === this.campaign.invoicingDetailsId);
        const agencyIndex = this.invoicingDetailsList.agency
          .findIndex((invDetails) => invDetails.id === this.campaign.invoicingDetailsId);
        this.selectedDetailsId = (advertiserIndex > -1 || agencyIndex > -1) ? this.campaign.invoicingDetailsId : null;

        if (advertiserIndex > -1) {
          this.selectedInvoiceType = 'advertiser';
          const advertiser = this.invoicingDetailsList.advertiser.splice(advertiserIndex, 1);
          this.invoicingDetailsList.advertiser = [...advertiser, ...this.invoicingDetailsList[this.selectedInvoiceType]];
        }
        if (agencyIndex > -1) {
          this.selectedInvoiceType = 'agency';
          const agency = this.invoicingDetailsList.agency.splice(agencyIndex, 1);
          this.invoicingDetailsList.agency = [...agency, ...this.invoicingDetailsList.agency];
        }
        this.updateSelection(this.selectedDetailsId);
      }
    }
  },
  watch: {
    selectedInvoiceType(newVal) {
      this.$emit('updateSelectionType', newVal);
    },
  },
};
</script>
<style scoped>
.invoicing-details-list{
  position: relative;
}
.read-only-overlay{
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: not-allowed;
  z-index: 9999;
}
</style>
